import Editor from './Welcome';

const Login = {
  Editor,
};

export default Login;
